import { Box, Checkbox, FormControl, Select, Skeleton } from '@mui/material';
import * as React from 'react';
import { memo } from 'react';
import NotificationErrorIcon from '../Icons/NotificationErrorIcon';
import { FeedbackWrapper, InputBaseWrapper, InputLabelWrapper } from '../TextInput/TextInputStyle';
import { MultipleDropdownProps } from './MultipleDropdownModels';
import MultipleDropdownMenuItemWrapper from './MultipleDropdownStyle';
import SelectedChipsRow from './SelectedChipsRow';

function MultipleDropdown({
  value = [],
  items,
  placeholder,
  label,
  subText,
  feedback,
  formStyle,
  showLoading = false,
  ...rest
}: MultipleDropdownProps) {
  /**
   * Renders the selected values or placeholder text when no values are selected
   * @param selected
   */
  const renderValue = (selected: string[]) => {
    if (selected.length === 0) {
      return placeholder || '';
    }
    const selectedItems = selected.map((val) => {
      const item = items.find((i) => i.value === val);
      return { key: val, label: item ? item.label : val };
    });
    return <SelectedChipsRow items={selectedItems} />;
  };

  return (
    <FormControl sx={{ width: '100%', ...formStyle }}>
      {label ? (
        <InputLabelWrapper shrink disabled={rest.disabled}>
          {label}
        </InputLabelWrapper>
      ) : null}
      {showLoading ? (
        <Skeleton width="100%" height="56px" sx={{ transform: 'none' }} />
      ) : (
        <Select
          multiple
          value={value}
          {...rest}
          input={<InputBaseWrapper />}
          displayEmpty
          renderValue={renderValue}
          MenuProps={{
            anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
            transformOrigin: { vertical: 'top', horizontal: 'left' },
            PaperProps: { style: { maxHeight: '29.5rem' } },
          }}
        >
          {items.map((item) => {
            const isSelected = value.includes(item.value);
            return (
              <MultipleDropdownMenuItemWrapper value={item.value} key={item.key} selected={isSelected}>
                <span>{item.label}</span>
                <Checkbox checked={isSelected} color="primaryCheckbox" sx={{ padding: 0 }} />
              </MultipleDropdownMenuItemWrapper>
            );
          })}
        </Select>
      )}
      {feedback ? (
        <FeedbackWrapper error={rest.error} component="span">
          {rest.error ? (
            <Box sx={{ paddingRight: '0.25rem' }}>
              <NotificationErrorIcon />
            </Box>
          ) : null}
          {feedback}
        </FeedbackWrapper>
      ) : null}
    </FormControl>
  );
}

export default memo(MultipleDropdown);
